// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Icon, theme } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'

const TableSortIcon = ({ ascending, descending, paddingLeft = 10 }) => (
  <div
    style={{
      ...styles.wrapper,
      paddingLeft
    }}
  >
    <span
      style={{
        ...styles.triangle,
        color: ascending ? theme.color.status.primary : colors.darkgrey
      }}
    >
      <Icon name="CaretUpFilled" />
    </span>
    <span
      style={{
        ...styles.triangle,
        color: descending ? theme.color.status.primary : colors.darkgrey
      }}
    >
      <Icon name="CaretDownFilled" />
    </span>
  </div>
)

const styles = {
  triangle: {
    width: 14,
    height: 6,
    marginBottom: 3
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    bottom: 4
  }
}

TableSortIcon.propTypes = {
  ascending: PropTypes.bool,
  descending: PropTypes.bool,
  paddingLeft: PropTypes.number
}

export default TableSortIcon
